"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceAddressService = void 0;
var CommonService_decorator_1 = require("../decorators/CommonService.decorator");
var PreloadData_service_1 = require("../../monolith/services/PreloadData.service");
var Url_service_1 = require("./Url.service");
var Http_service_1 = require("./http/Http.service");
var typedi_1 = require("typedi");
var ServiceAddressService = /** @class */ (function () {
    function ServiceAddressService(httpService, urlService, preloadDataService) {
        this.httpService = httpService;
        this.urlService = urlService;
        this.preloadDataService = preloadDataService;
    }
    /**
     * @deprecated
     * Please use `getAllServiceAddresses` instead
     * <br/>
     * Returns information about tenant such as which environment (QA, dev, etc) and service addresses for common
     * APIs: Blob Service, Download Service, etc.
     * Caches on session storage for 60 minutes.
     */
    ServiceAddressService.prototype.getServiceAddresses = function () {
        return __awaiter(this, void 0, void 0, function () {
            var instance, url;
            return __generator(this, function (_a) {
                instance = typedi_1.Container.get('instance');
                url = "https://service-discovery.seismic.com/api/sds/v1/tenants/" + instance.getSubdomain() + "/services?useEdgeComputing=true";
                return [2 /*return*/, this.httpService.get(url, { cache: 'variable', cacheExpirationMinutes: 60 })];
            });
        });
    };
    /**
     * Returns information about tenant such as which environment (QA, dev, etc) and service addresses for common
     * APIs: Blob Service, Download Service, etc.
     * Caches on session storage for 60 minutes.
     */
    ServiceAddressService.prototype.getAllServiceAddresses = function () {
        return __awaiter(this, void 0, void 0, function () {
            var preloadServiceAddresses, instance, url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        preloadServiceAddresses = this.getPreloadServiceAddresses();
                        if (preloadServiceAddresses) {
                            return [2 /*return*/, preloadServiceAddresses];
                        }
                        instance = typedi_1.Container.get('instance');
                        url = "https://service-discovery.seismic.com/api/sds/v1/tenants/" + instance.getSubdomain() + "/services?useEdgeComputing=true";
                        return [4 /*yield*/, this.httpService.get(url, {
                                cache: 'variable',
                                cacheExpirationMinutes: 60,
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.serviceAddress];
                }
            });
        });
    };
    ServiceAddressService.prototype.getServiceAddressByKey = function (key) {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAllServiceAddresses()];
                    case 1:
                        url = (_a.sent())[key];
                        return [2 /*return*/, this.urlService.normalizeDomain(url)];
                }
            });
        });
    };
    /**
     * For internal use, only for monolith apps where appData is preloaded.
     */
    ServiceAddressService.prototype.getPreloadServiceAddresses = function () {
        var preloadData = this.preloadDataService.getPreloadData();
        var preloadServiceAddresses = preloadData === null || preloadData === void 0 ? void 0 : preloadData.sdsAddresses;
        if (!preloadServiceAddresses) {
            return;
        }
        return Object.fromEntries(preloadServiceAddresses.map(function (a) { return [a.Key, a.Value]; }));
    };
    /**
     * Only use for monolith apps where appData is preloaded.
     * Do not use in standalone apps unless there is window.appDatas.sdsAddresses available.
     */
    ServiceAddressService.prototype.getPreloadServiceAddressByKey = function (key) {
        var preloadServiceAddresses = this.getPreloadServiceAddresses();
        if (!preloadServiceAddresses) {
            return;
        }
        var url = preloadServiceAddresses[key];
        return this.urlService.normalizeDomain(url);
    };
    ServiceAddressService = __decorate([
        CommonService_decorator_1.CommonService('ServiceAddressService'),
        __metadata("design:paramtypes", [Http_service_1.HttpService,
            Url_service_1.UrlService,
            PreloadData_service_1.PreloadDataService])
    ], ServiceAddressService);
    return ServiceAddressService;
}());
exports.ServiceAddressService = ServiceAddressService;
//# sourceMappingURL=ServiceAddress.service.js.map